unit x.WebSocket.Shared;

interface

uses classes, system.generics.collections, x.json, x.ao, libloginfo, liblogtest;

const
  // From Client
  mkInit = 'mkinit';
  mkInit2='mkinit2'; //not used
  mkFN = 'mkfn';
  mkVAL='mkval';   //datastring is a single name=value pair
  mkVALS='mkvals'; //datastring is a complete set of vals

  // From server
  mkGuid = 'mkGuid';
  mktext = 'mktext';
  mkClients='mkclients';
  mkReInit='mkreinit'; //request init string again

  type
   tXWSclientbase = class;

  //Server features
  txwsFTOtherCLients=class
    private
    Fenabled: boolean;
    FFullInfo: boolean;
    public
    published
     property enabled: boolean read Fenabled write Fenabled;
     property FullInfo: boolean read FFullInfo write FFullInfo;
  end;

     //Eventbus code should go into tao

  tXWSmsg = class;
  //twsClientMessageEvent = procedure(aMsg: twsMessage) of object;

    //Event bus
   //twcEventType=(CeCon, ceDisCon, ceError, ceMsg,ceGotGuid);

   tXWSevent=procedure(sender: txwsClientBase; aMsg: txWSMsg) of object;
   {$IFDEF WEBLIB}
       tXWSevents=tlist;
   {$ELSE}
        tXWSevents=tlist<tXWSevent>;
   {$ENDIF}



  tXWSclientbase = class (tao)
  private
    Fguid: string;

    FAutoConnect: boolean;
    FAutoDisConnect: boolean;
    fClientInfo: tLogInfo;
    Fgoing: boolean;
    Fname: string;
    Fvalues: string;
    Factive: boolean;
    FisCC: boolean;
    FisServer: boolean;

    function getGuidShort: string;
    function GetName: string;
    procedure setValues(const Value: string);
  public
    EventBus: txWSEvents;
    ValList: tStringlist;
    function getValue(aname: string):string;
    procedure SetValue(aname, avalue: string);
      procedure EventWatch(aProc: tXWSevent);
    procedure EventRemove(aproc: tXWSevent);
      procedure DoEvent(aMsg: txWSMsg);
    procedure setGuid(const Value: string);
    constructor create; override;

    procedure doInit; virtual;
    procedure Send(aMsg: txWSMsg); virtual;
    procedure SendGuid;virtual;
    procedure sendText(atext: string);
    procedure connect; virtual;
    procedure disConnect; virtual;
    procedure Log(aMsg: String; aData: tobject); overload;
    procedure Log(aMsg: String); overload;
  published
    property guid: string read Fguid write setGuid;
    property guidShort: string read getGuidShort;
    property going: boolean read Fgoing write Fgoing;
    property AutoConnect: boolean read FAutoConnect write FAutoConnect;
    property AutoDisConnect: boolean read FAutoDisConnect write FAutoDisConnect;
    property ClientInfo: tLogInfo read fClientInfo write fClientInfo;
    property name: string read GetName write Fname;
    property values: string read Fvalues write setValues;
    property active: boolean read Factive write Factive;
     property isCC: boolean read FisCC write FisCC;
    property isServer: boolean read FisServer write FisServer;
  end;

  tXWSmsg = class
  private
    Fguid: string;
    FKind: string;
    Fdata: tobject;
    Ffn: string;
    FDataString: string;
    FMsgGuid: string;
    FReplyGuid: string;
    FParam: string;
    FCmd: string;
    FrelayGuid: string;
    FdataString2: string;
  public

    function GetJson: string;
    constructor create; overload;
    constructor create(aFromJson: string); overload;
    constructor new(akind: string); overload;
    constructor new(akind: string;afn: string; aData: tobject;
      aDataString: string);  overload;
    constructor newText(atext: string; adata: tobject=nil);
    constructor newFN(afn: string; adata: tobject; aDataString: string='');

  published
    property guid: string read Fguid write Fguid;
    property Kind: string read FKind write FKind;
    property fn: string read Ffn write Ffn;
    property data: tobject read Fdata write Fdata;
    property DataString: string read FDataString write FDataString;
    property dataString2: string read FdataString2 write FdataString2;
    property MsgGuid: string read FMsgGuid write FMsgGuid;
    property ReplyGuid: string read FReplyGuid write FReplyGuid;
    property Cmd: string read FCmd write FCmd;
    property Param: string read FParam write FParam;
    property relayGuid: string read FrelayGuid write FrelayGuid;
  end;

  txwsMsgList=tobjectlist<txwsmsg>;

var
  WsCurGuid: String;

implementation
     uses Sysutils;


constructor tXWSmsg.create(aFromJson: string);
begin
  create;

  xjtoObject(aFromJson, self);
end;

procedure txWSclientbase.EventRemove(aproc: tXWSevent);
var
 i: integer;
 ae: tXWSevent;
begin
 {$IFDEF WEBLIB}
    for i:=1 to Eventbus.Count do
 begin
  ae:=tXWSevent(eventbus[i-1]);

 end;
 {$ELSE}
   if eventBus.IndexOf(aproc)<>-1 then eventbus.remove(aproc);
 {$ENDIF}

end;

procedure txWSclientbase.EventWatch(aProc: tXWSevent);
var
 i: integer;
 ae: tXWSevent;
begin
{$IFDEF fwWeb}

  eventbus.Add(aproc);
{$ELSE}
 if eventBus.IndexOf(aproc)=-1 then eventbus.add(aproc);

{$ENDIF}


end;

function tXWSmsg.GetJson: string;
begin
  result := xj(self);
end;

constructor tXWSmsg.new(akind, afn: string; aData: tobject;
  aDataString: string);
begin
  create;
  kind:=aKind;
  fn:=afn;
  Data:=aData;
  DataString:=aDataString;
end;

constructor tXWSmsg.newFN(afn: string; adata: tobject; aDataString: string);
begin
  new(mkFN, afn, adata, adatastring);
end;

constructor tXWSmsg.newText(atext: string; adata: tobject);
begin
   new(mkText, '', adata, atext);
end;

constructor tXWSmsg.new(akind: string);
begin
  new(akind, '', nil, '');
end;

constructor tXWSmsg.create;
begin
  MsgGuid:=FloatToStr(now);
end;

{ txWSclientbase }

procedure txWSclientbase.connect;
begin

end;

constructor txWSclientbase.create;
begin
  //alog.send('txWSclientbase.create');
 inherited;
 EventBus:=tXWSevents.Create;
 ClientInfo:=tLogInfo.create;
 ValList:=tStringlist.Create;
end;

procedure txWSclientbase.disConnect;
begin

end;

procedure txWSclientbase.DoEvent(aMsg: tXWSmsg);
var
 i: integer;
 ae: tXWSevent;
begin
 {$IFDEF WEBLIB}
   for i:=1 to Eventbus.Count do
 begin
  ae:=tXWSevent(eventbus[i-1]);
  ae(self,amsg);
 end;
 {$ELSE}
  //alog.send('DoEvent', eventbus.count);
    for ae in EventBus do
 begin

  ae(self,amsg);
 end;
 {$ENDIF}

 // if eventBus.IndexOf(aproc)<>-1 then eventbus.remove(aproc);
 //eventbus.Remove(aproc);
end;

procedure txWSclientbase.doInit;
begin

end;

function txWSclientbase.getGuidShort: string;
begin
  result := Fguid;
  if length(result) > 4 then
    result := copy(result, 1, 4);
end;


function tXWSclientbase.GetName: string;
begin
 try

 if fname<>'' then
 begin
  Result := Fname;
  exit;
 end;
 if GetValue('name')<>'' then
 begin
   result:=getValue('name');
   exit;
 end;

 if assigned(ClientInfo) then
 begin
   result:=clientINfo.DeviceName;
   exit;
 end;
 Result:=guid;
 except
  on e: exception do
  begin
    result:='error';
  end;

 end;
end;

function tXWSclientbase.getValue(aname: string): string;
begin
 if valList.IndexOfName(aname)<>-1 then result:=valList.Values[aname] else result:='';

end;

procedure tXWSclientbase.Log(aMsg: String);
var
 s: String;
begin
 s:=name + ' [' + GuidShort + ']: ';
  if isServer then    s:='[ON SERVER] ' + s;

 alog.send(s+amsg);

end;

procedure tXWSclientbase.Log(aMsg: string; aData: tobject);
var
 s: String;
begin
 s:=name + ' [' + GuidShort + ']: ';
 if isServer then    s:='[ON SERVER] ' + s;

 alog.send(s+amsg, aData);
end;

procedure txWSclientbase.Send(aMsg: tXWSmsg);
begin
 if AutoConnect then
 begin
  if fActive=false then
  begin
   log('AutoConnecting');
   Connect;
  end;
 end;

 aMsg.guid:=guid;
end;

procedure tXWSclientbase.SendGuid;
begin

end;

procedure txWSclientbase.sendText(atext: string);
var
 amsg: tXWSmsg;
begin
   amsg:=tXWSmsg.newText(atext);
  send(amsg);
end;

procedure txWSclientbase.setGuid(const Value: string);
begin
  Fguid := Value;
  AOGS:=value;
   wsCurGuid:=value;
end;

procedure tXWSclientbase.SetValue(aname, avalue: string);
begin
 valList.Addpair(aname, avalue);
 fValues:=valList.Text;
end;

procedure tXWSclientbase.setValues(const Value: string);
begin
 //if not assigned(valList) then ValList:=tstringlist.Create;

  Fvalues := Value;
  ValList.Text:=value;
end;

initialization
RegisterCLass(tXWSclientbase);

end.
